module.exports = global["ReactDOM"] = require("-!.\\index.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/expose-loader?ReactDOM!./node_modules/react-dom/index.js-exposed
// module id = 546
// module chunks = 0 1